import { render, staticRenderFns } from "./DataTestCenter.vue?vue&type=template&id=314f4fd0&"
import script from "./DataTestCenter.vue?vue&type=script&lang=js&"
export * from "./DataTestCenter.vue?vue&type=script&lang=js&"
import style0 from "./DataTestCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports